import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
import { onFilmListLoadSuccess } from './utils/on-success';
export const loadAllFilms = async () => {
    await loadDataFromApi({
        api: ocapiClient.instance.v1.browsing.masterData.films.getAll,
        state: browsingDomainStore.data.allFilmIds,
        cacheDuration: getCacheDuration('films'),
        onSuccess: onFilmListLoadSuccess
    });
};
